import { BlockEditProps } from '@wordpress/blocks'
// @ts-ignore
import ServerSideRenderOriginal from '@wordpress/server-side-render'
import React from 'react'

export type ServerSideRenderProps = BlockEditProps<any>

const preventDefault = (e: { preventDefault: () => unknown }) =>
  e.preventDefault()

export default function ServerSideRender(
  props: ServerSideRenderProps
): JSX.Element {
  return (
    <div onClick={preventDefault} onSubmit={preventDefault}>
      <ServerSideRenderOriginal
        block={(props as unknown as { name: string }).name}
        className="prevent-clicks"
        attributes={props.attributes}
      />
    </div>
  )
}
